// Small hand-authored line icons for the top nav — inline SVG, no icon
// library or external assets, consistent with the rest of the app.
import type { SVGProps } from 'react';

function Icon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={`h-4 w-4 ${className ?? ''}`}
      {...props}
    />
  );
}

export function DashboardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <rect x="2.5" y="2.5" width="6" height="6" rx="1" />
      <rect x="11.5" y="2.5" width="6" height="6" rx="1" />
      <rect x="2.5" y="11.5" width="6" height="6" rx="1" />
      <rect x="11.5" y="11.5" width="6" height="6" rx="1" />
    </Icon>
  );
}

export function HistoryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="10" cy="10.5" r="7" />
      <path d="M10 6.5v4l2.5 2" />
    </Icon>
  );
}

export function StarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M10 2.8 12.2 7.6 17.4 8.3 13.7 12 14.6 17.2 10 14.7 5.4 17.2 6.3 12 2.6 8.3 7.8 7.6Z" />
    </Icon>
  );
}

export function ProfileIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="10" cy="7" r="3.2" />
      <path d="M3.5 17c1-3.3 4-5 6.5-5s5.5 1.7 6.5 5" />
    </Icon>
  );
}

export function HelpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="10" cy="10" r="7.3" />
      <path d="M7.8 8.1c.3-1.4 1.4-2.1 2.6-2.1 1.3 0 2.5.8 2.5 2.1 0 1.6-2.5 1.8-2.5 3.7" />
      <circle cx="10" cy="14.3" r="0.15" fill="currentColor" stroke="none" />
    </Icon>
  );
}

export function BellIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M5 14.5c0-1 .6-1.3.6-3.6 0-3 1.7-5 4.4-5s4.4 2 4.4 5c0 2.3.6 2.6.6 3.6Z" />
      <path d="M8.3 16.8c.4.7 1 1.1 1.7 1.1s1.3-.4 1.7-1.1" />
    </Icon>
  );
}
